import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import yinyang from './wotcog.png';

function AppNav() {
  return (
    <>
      <Navbar bg="primary" variant="dark" expand="lg" className="py-2">
        <Container>
          <LinkContainer to="/">
            <Navbar.Brand>
              <img src={yinyang} alt="Logo" /> WoTCode
            </Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <LinkContainer to="/skills">
                <Nav.Link>Skill Trainer</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/weaves">
                <Nav.Link>Weave Trainer</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/eqtrainer">
                <Nav.Link>Equipment Trainer</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/equipment">
                <Nav.Link>Equipment</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/mobs">
                <Nav.Link>Mobs</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/map">
                <Nav.Link>Map</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/stats">
                <Nav.Link>Stats</Nav.Link>
              </LinkContainer>
              <LinkContainer to="/scripts">
                <Nav.Link>Scripts</Nav.Link>
              </LinkContainer>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default AppNav;
